import React from 'react'
import { WriterModel } from '@Entities/work/writer-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { RecordingModel } from '@Entities/work/recording-model'

interface WorkItemSimpleSubInfoProps {
    writers: WriterModel[]
    originalPublishers: OriginalPublisherModel[]
    allPublishersCount: number
    recordings: RecordingModel[]
}

const WorkItemSimpleSubInfo = ({
    writers,
    originalPublishers,
    allPublishersCount,
    recordings,
}: WorkItemSimpleSubInfoProps) => (
    <div className="item-sub-info">
        <div>
            <p className="small-2">Writer ({writers && writers.length ? writers.length : 0})</p>
            {writers && writers.length ? (
                <p className="small-2 bold">
                    {writers[0].firstName} {writers[0].lastName}
                </p>
            ) : null}
        </div>
        <div>
            <p className="small-2">Publishers ({allPublishersCount})</p>
            {originalPublishers && originalPublishers.length ? (
                <p className="small-2 bold">{originalPublishers[0].publisherName}</p>
            ) : null}
        </div>
        <div>
            <p className="small-2">Recordings ({recordings && recordings.length ? recordings.length : 0})</p>
            {recordings && recordings.length ? <p className="small-2 bold">{recordings[0].title}</p> : null}
        </div>
        <div>
            <p className="small-2">Artists ({recordings && recordings.length ? recordings.length : 0})</p>
            {recordings && recordings.length ? <p className="small-2 bold">{recordings[0].artistName}</p> : null}
        </div>
    </div>
)

export default WorkItemSimpleSubInfo
